import React from 'react';
import {InputField, CalendarField, CheckboxField, ButtonFields, View, CardSimples} from 'react-template';
import Select from './Select';
import moment from 'moment'
import "../../../assets/css/components/formbuilder/formItensElements/formBuilderItem.css"

const options = [{ value: 'textocurto', text: 'Texto curto' },
                 { value: 'textocurto-cpf', text: 'Campo de CPF' },
                 { value: 'textocurto-cnpj', text: 'Campo de CNPJ' },
                 { value: 'textocurto-telefone', text: 'Campo de Telefone' },
                 { value: 'textocurto-cep', text: 'Campo de CEP' },
                 { value: 'textocurto-dinheiro', text: 'Monetário' },
				 { value: 'textolongo', text: 'Texto longo' },
                 { value: 'email', text: 'Email' },
				 { value: 'numero', text: 'Número' },
				 { value: 'data', text: 'Data' },
				 { value: 'select', text: 'Lista' },
				 { value: 'radio', text: 'Múltipla escolha' },
                 { value: 'checkbox', text: 'Caixas de seleção' },
                 { value: 'arquivo', text: 'Arquivo' }]

class FormBuilderItem extends View {
    
    constructor(props) {
		super(props);
        this.delete = this.delete.bind(this);
        this.setObrigatorio = this.setObrigatorio.bind(this);
        this.setPergunta = this.setPergunta.bind(this);
        this.getFieldName = this.getFieldName.bind(this);
        this.temOpcoes = this.temOpcoes.bind(this);
        this.mostarModal = this.mostarModal.bind(this);
        this.setCertificado = this.setCertificado.bind(this);
        this.setValor = this.setValor.bind(this);
        this.setLimiteVagas = this.setLimiteVagas.bind(this);
        this.setValorPredefinido = this.setValorPredefinido.bind(this);
        this.setConteudoValorPredefinido = this.setConteudoValorPredefinido.bind(this);
        this.ehDesabilitado = (this.props.ordem === '1' || this.props.ordem === '2' || this.props.ordem === '3');
        this.deletarehDesabilitado = this.getDesabilitaDelete();
        this.obrigatorioehDesabilitado = this.getDesabilitaObrigatorio();
        this.state = {temValor: false, temLimite: false}
	}

    getDesabilitaDelete(){
        let ordem = parseInt(this.props.ordem, 10)
        if(this.props.tipoForm === 'form'){
            return ((ordem >= 1 && ordem <= (this.props.temBoleto ? 8 : 3)) || this.itemEvento());
        }else{ // GRU
            return (ordem >= 1 && ordem <= 9);
        }
    }

    getDesabilitaObrigatorio(){
        let ordem = parseInt(this.props.ordem, 10)
        if(this.props.tipoForm === 'form'){//sem boleto 1-3 **** com boleto 1-5 e 8
            return ((this.props.temBoleto ? ((ordem >= 1 && ordem <= 5) || ordem === 8) : (ordem >= 1 && ordem <= 3)) || this.props.item.tipo === 'radio' || this.itemEvento());
        }else{ // GRU
            return ((ordem >= 1 && ordem <= 6) || ordem === 9 || this.props.item.tipo === 'radio');
        }
    }

    componentWillMount(){
        this.setState({temValor: (this.agregaValor() ? (this.props.item.opcoes[0].valor !== undefined) : false),
                       temLimite: (this.temOpcoes(this.props.item.tipo) ? (this.props.item.opcoes[0].limiteDeVagas !== undefined) : false)});
    }

    temOpcoes(tipo){
        return (tipo === 'select' || tipo === 'radio' || tipo === 'checkbox');
    }
    
    getFieldName(value){
        return options.filter(option => (
            option.value === value
        ))[0].text;
    }
    
    delete = () => {
        this.props.actions.deleteItem(this.props.item.id);
    }

    setObrigatorio(){
        this.props.actions.updateItem({...this.props.item, obrigatorio: !this.props.item.obrigatorio});
    }

    setPergunta(e, data){
        this.props.actions.updateItem({...this.props.item, pergunta: data.value});
    }

    setCertificado(e, data){
        if(data.checked){ //se emite certificado
            this.props.actions.updateItem({...this.props.item,
                certificado: true});
        }else{ //se NÃO emite certificado
            this.props.actions.updateItem({...this.props.item,
                certificado: false});
        }
        this.forceUpdate();
    }

    setValor(temValor){
        this.setState({...this.state, temValor: temValor});
        if(temValor){ //se tem valor
            this.props.actions.updateItem({...this.props.item,
                opcoes: this.props.item.opcoes.map(itemN => itemN = {...itemN, valor: '0,00'} )
            });
        }else{ //se NÃO  tem valor
            this.props.actions.updateItem({...this.props.item,
                opcoes: this.props.item.opcoes.map(itemN => itemN = {...itemN, valor: undefined} ),
            });
        }
        this.forceUpdate();
    }

    setLimiteVagas(e, data){
        let temLimite = data.checked;
        this.setState((prevState, props) => {
            return {temLimite: !prevState.temLimite}
        });
        if(temLimite){ //se tem limite de vagas
            this.props.actions.updateItem({...this.props.item,
                opcoes: this.props.item.opcoes.map(itemN => itemN = {...itemN, limiteDeVagas: 1} )
            });
        }else{ //se NÃO tem limite de vagas
            this.props.actions.updateItem({...this.props.item,
                opcoes: this.props.item.opcoes.map(itemN => itemN = {...itemN, limiteDeVagas: undefined} )
            });
        }
        
        this.forceUpdate();
    }

    mostarModal(){
        this.displayModal(  'Você tem certeza que quer apagar este campo?', '',
            'Clique no botão de concordar para apagar.',this.delete);
    }

    agregaValor(){
        return (this.temOpcoes(this.props.item.tipo) && this.props.temBoleto);
    }

    //se o formulario não tem mais boleto os valores das opcoes sao retirados
    componentDidUpdate(prevProps, prevState){
        if(!this.agregaValor() && this.state.temValor){
            this.setValor(false);
        }
    }

    temCertificado(){
        return (this.props.item.tipo === 'select' && !this.props.tipoForm !== 'gru' && !this.itemEvento());
    }

    temLimiteVagas(){
        return (this.temOpcoes(this.props.item.tipo) && this.props.tipoForm !== 'gru' && !this.itemEvento());
    }

    itemEvento(){
        const evento = this.props.evento;
        return (evento !== undefined ? evento === this.props.itemId && evento > 0 : false)
    }

    mostrarDescrição(){
        return this.ehDesabilitado && !this.mostrarOpcaoValorPredefinido();
    }

    mostrarOpcaoValorPredefinido(){
        return this.props.tipoForm === 'gru' && (this.props.itemId === 2 || this.props.itemId === 3);
    }

    getDataAtual(){
        const data = new Date().toDateString();
        return moment(data).format('YYYY-MM-DD')
    }

    setValorPredefinido(checked, tipo){
        const valor = (tipo === 'textocurto-dinheiro' ? '0,00' : this.getDataAtual());
        if(checked){ //se tem valor predefinido
            this.props.actions.updateItem({...this.props.item,
                valor: valor});
        }else{ //se NÃO tem valor predefinido
            this.props.actions.updateItem({...this.props.item,
                valor: undefined});
        }
        this.forceUpdate();
    }

    setConteudoValorPredefinido(value, tipo){
        let valorPredefinido = value;
        this.props.actions.updateItem({...this.props.item, valor: valorPredefinido});
    }

    temValorPredefinido(){
        return this.props.item.valor !== undefined;
    }

    getTypeInput(tipo){

        if(tipo === 'textocurto-dinheiro'){
            return (
                <InputField
                    name={`valor-predefinido-${tipo}`} 
                    className={this.getClassNameValorPredefinido()} 
                    disabled={!this.temValorPredefinido()}
                    value={this.getValorPredefinido()} 
                    placeholder={this.props.item.pergunta}
                    required
                    invalidMessage="Campo Obrigatório"
                    label={this.props.item.pergunta}
                    onChange={(e, data) => this.setConteudoValorPredefinido(data.value, tipo)}
                    />
            )
        }else if(tipo){
            return (
                <CalendarField
                    id={`valor-predefinido-${tipo}`}
                    name={`valor-predefinido-${tipo}`}
                    className={this.getClassNameValorPredefinido()} 
                    disabled={!this.temValorPredefinido()} 
                    value={this.getValorPredefinido()} 
                    placeholder={this.props.item.pergunta} 
                    label={this.props.item.pergunta} 
                    onChange={(e, data) => this.setConteudoValorPredefinido(data.value, tipo)}
                    calendarConfig={{type: 'date', minDate: new Date()}}/>
            )
        }
    }

    getValorPredefinido(){
        if(this.props.item.valor !== undefined){
            return this.props.item.valor
        }else{
            return '';
        }
    }

    getClassNameValorPredefinido(){
        return (this.props.item.tipo === 'textocurto-dinheiro' ? 'money_mask' : '');
    }

    getCheckOptions(){
        return (
            <div className="width-100">
                {this.mostrarDescrição() &&
                    <div className='m-l-8'>
                        O <b>{this.props.item.pergunta}</b> é um campo obrigatório no formulário
                    </div>
                }
                {this.itemEvento() &&
                    <div className='m-l-8'>
                        <b>Campo de Evento</b>
                    </div>
                }
                {this.mostrarOpcaoValorPredefinido() &&
                    <div className='ui left floated' >
                        <CheckboxField rightLabel className='m-r' value={this.temValorPredefinido()} label='Valor predefinido' onChange={(e, data) => this.setValorPredefinido(data.checked, this.props.item.tipo)}/>
                        {this.getTypeInput(this.props.item.tipo)}
                    </div>
                }
                <div className='check-opcoes'>
                    { this.temCertificado() && <CheckboxField rightLabel className='m-r' label='Certificado' value={this.props.item.certificado} onChange={this.setCertificado}/>}
                    { this.agregaValor() && <CheckboxField rightLabel className='m-r' label='Agrega valor' value={this.state.temValor} onChange={(e, data) => this.setValor(data.checked)} disabled={this.itemEvento()}/>}
                    { this.temLimiteVagas() && <CheckboxField rightLabel className='m-r' name={'limiteVagas-'+this.props.item.id} label='Limite de vagas' value={this.state.temLimite} onChange={this.setLimiteVagas}/> }
                    <CheckboxField rightLabel className='m-r' disabled={this.obrigatorioehDesabilitado} value={this.props.item.obrigatorio} label='Obrigatório' onChange={this.setObrigatorio}/>                                
                </div>
            </div>
        )
    }

    getButtonTools(){
        return(
            <div>
                <ButtonFields disabled={this.props.disabledUpCampo} type="button" button="fab" icon="arrow_drop_up" color="transparent" onClick={() => this.props.upCampo(this.props.item)} mini/>
                <ButtonFields disabled={this.props.disabledDownCampo} type="button" button="fab" icon="arrow_drop_down" color="transparent" onClick={() => this.props.downCampo(this.props.item)} mini/>
                <ButtonFields disabled={this.deletarehDesabilitado}  onClick={this.mostarModal} type="button" button="fab" icon="delete" color="transparent" mini/>
            </div>
        )
    }

    render() {
        const tipo = this.props.item.tipo
        return (
            <CardSimples titulo={`Campo ${this.props.ordem}`} descricao={this.getFieldName(tipo)} borderBottom tools={this.getButtonTools()} form>
                <div id={`area-item-${this.props.ordem - 1}`}>
                    <InputField
                        className=""
                        disabled={this.ehDesabilitado} 
                        value={this.props.item.pergunta} 
                        name={`item-${this.props.ordem - 1}`}
                        onChange={this.setPergunta}
                        required
                        invalidMessage="Campo Obrigatório"
                        label='Título'                                        
                        />

                    { this.temOpcoes(tipo) &&
                        <div>
                            <Select 
                                item={this.props.item} 
                                actions={this.props.actions} 
                                temValor={this.state.temValor} 
                                temLimite={this.state.temLimite} 
                                itemEvento={this.itemEvento()}/>
                        </div>
                    }
                </div>
                {this.getCheckOptions()}
            </CardSimples>
        );
    }
}

export default FormBuilderItem;


// WEBPACK FOOTER //
// ./src/components/formbuilder/formItensElements/FormBuilderItem.js